<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Отчеты</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">
        <b-dropdown
            variant="success"
            text="Сформировать новый отчет"
            v-if="isUniversityManager()"
            class="d-inline-block"
            size="md"
        >
          <b-dropdown-item
              v-for="(type, key) in reportTypes"
              :key="key"
              @click="onClickGenerateReport(key)"
          >
            {{ type }}
          </b-dropdown-item>
        </b-dropdown>

      </div>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск"
                       id="iin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isAdmin() || isManagerFC() || isAudit() || isUniversityManager() || isRector()">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9" v-if="isAdmin() || isManagerFC() || isAudit()">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>



        <div class="row col-md-9" v-if="isUniversityManager() || isManagerFC() || isAdmin() || isAudit()">
          <div class="el-input-group">
            <label for="reportStatus" class="form-label col-md-3">
              Статус
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.reportStatus" id="reportStatus"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="statusKey in Object.keys(reportStatuses)" :key="statusKey"
                        :value="statusKey">
                  {{ reportStatuses[statusKey] }}
                </option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                v-if="isManagerFC() || isAdmin() || isAudit()"
                :disabled="items.length === 0"
                @click="onClickExportReports()">
        Экспортировать в MS Excel
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(bin)="data">
        <div class="sortable-container none col-bin"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН
        </div>
      </template>
      <template #head(universityName)="data">
        <div class="sortable-container none col-university"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          ВУЗ
        </div>
      </template>
      <template #head(name)="data">
        <div class="sortable-container none col-name"
             @click="onSortChanged('name')"
             :class="{'ascending': page.sort.name === 'ASC', 'descending': page.sort.name === 'DESC'}">
          Документ
        </div>
      </template>
      <template #head(totalSum)="data">
        <div class="sortable-container none col-total-sum"
             @click="onSortChanged('totalSum')"
             :class="{'ascending': page.sort.totalSum === 'ASC', 'descending': page.sort.totalSum === 'DESC'}">
          Общая сумма
        </div>
      </template>
      <template #head(reportType)="data">
        <div class="sortable-container none col-report-type-count"
             @click="onSortChanged('reportType')"
             :class="{'ascending': page.sort.reportType === 'ASC', 'descending': page.sort.reportType === 'DESC'}">
          Тип отчета
        </div>
      </template>
      <template #head(reportStatus)="data">
        <div class="sortable-container none col-status"
             @click="onSortChanged('reportStatus')"
             :class="{'ascending': page.sort.reportStatus === 'ASC', 'descending': page.sort.reportStatus === 'DESC'}">
          Статус
        </div>
      </template>
      <template #head(files)="data">
        <div class="col-files"></div>
      </template>
      <template #head(actions)="data" v-if="canViewRemove()">
        <div class="col-actions"></div>
      </template>

      <template #cell(bin)="data">
        <div class="col-bin">
          {{ data.item.university.bin }}
        </div>
      </template>
      <template #cell(universityName)="data">
        <div class="col-university">
          {{ data.item.university.nameRu }}
        </div>
      </template>
      <template #cell(name)="data">
        <div class="col-name" v-if="canViewReport(data.item)">
          <a :href="`/reports/${data.item.uuid}`">
            {{ data.item.name }}
          </a>
        </div>
        <div class="col-name" v-else>
          {{ data.item.name }}
        </div>
      </template>
      <template #cell(totalSum)="data">
        <div class="col-total-sum">
          {{ data.item.totalSum }}
        </div>
      </template>
      <template #cell(reportType)="data">
        <div class="col-report-type-count">
          {{ ReportType[data.item.reportType].nameRu }}
        </div>
      </template>
      <template #cell(reportStatus)="data">
        <div class="col-status" :class="getStatusClass(data.item.reportStatus)">
          {{ translateStatus(data.item.reportStatus) }}
        </div>
      </template>
      <template #cell(files)="data">
        <div class="col-files d-inline">
          <el-button type="text" class="btn-icon btn-excel"
                     v-if="data.item.excelFileId"
                     :disabled="!data.item.excelFileId"
                     @click="onClickDownloadFile(data.item.excelFileId, data.item.name, 'xlsx')">
            <font-awesome-icon :icon="['fas', 'file-excel']"/>
          </el-button>

          <el-button type="text" class="btn-icon btn-pdf"
                     v-if="data.item.pdfFileId"
                     :disabled="!data.item.pdfFileId"
                     @click="onClickDownloadFile(data.item.pdfFileId, data.item.name, 'pdf')">
            <font-awesome-icon :icon="['fas', 'file-pdf']"/>
          </el-button>
        </div>
      </template>
      <template #cell(actions)="data" v-if="canViewRemove()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    v-if="canRemove(data.item)"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>
import reportService from "@/services/reportService";
import fileService from "@/services/fileService";
import {ReportTypeEnum} from "@/enum/ReportTypeEnum";
import VueLoading from "vue-loading-overlay";
import delegationService from "@/services/delegationService";
import universityService from "@/services/universityService";
import settingsService from "@/services/settingsService";
import {showErrorNotify, showInfoNotify, showSuccessNotify} from "@/utils/notificationUtils";
import {ReportStatusEnum} from "@/enum/ReportStatusEnum";
import xlsExportService from "@/services/xlsExportService";
import {saveAs} from "@/assets/FileSaver.min";
import {UniversityEnum} from "@/enum/UniversityEnum";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      page: {
        filter: {
          search: null,
          trancheYear: null,
          trancheNumber: null,
          universityId: null,
          reportType: ReportTypeEnum.STATE_ORDER_1COURSE.code,
          reportStatus: null
        },
        sort: {
          universityName: null,
          bin: null,
          name: null,
          totalSum: null,
          reportType: null,
          reportStatus: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'name', label: 'Документ', sortable: true},
        {key: 'totalSum', label: 'Общая сумма', sortable: true},
        {key: 'reportType', label: 'Тип отчета', sortable: true},
        {key: 'reportStatus', label: 'Статус', sortable: true},
        {key: 'files', label: 'Файлы', sortable: false},
        {key: 'actions', label: '', sortable: false}
      ],
      items: [],
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i),
      universities: [],
      reportStatuses: {
        QUEUED: 'В очереди на формирование отчета',
        FILES_GENERATING: 'Отчет формируется',
        FILES_GENERATED: 'Отчет сформирован', // Файлы сформированы, доступно для менеджеров вузов
        SENT_FOR_APPROVAL: 'Отправлен на согласование', // Отправлен менеджеру финансового центра
        REJECTED_BY_FINANCIAL_CENTER: 'Отклонен менеджером финансового центра', // Отклонен финансовым центром
        SENT_TO_RECTOR: 'Отправлен ректору', // Отправлен ректору вуза
        SIGNED_BY_RECTOR: 'Подписан ректором', // Подписан ректором
        REJECTED_BY_RECTOR: 'Отклонен ректором',
        ERROR_ON_FILES_GENERATING: 'Возникла неизвестная ошибка при формировании файлов',
      },
      reportTypes: {'STATE_ORDER_1COURSE': ReportTypeEnum.STATE_ORDER_1COURSE.nameRu},
      selectedReportType: ReportTypeEnum.STATE_ORDER_1COURSE.code,
      ReportType: ReportTypeEnum
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });

      if (this.isAdmin() || this.isManagerFC() || this.isAudit()) {
        const fields = [];
        fields.push({key: 'bin', label: 'БИН ВУЗа', sortable: true});
        fields.push({key: 'universityName', label: 'ВУЗ', sortable: true});
        this.fields.unshift(fields[1]);
        this.fields.unshift(fields[0]);
      }
    },
    async reloadList() {
      this.isLoading = true;
      const response = await reportService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    async onClickGenerateReport(reportType) {
      try {
        const currentUserUniversityInfo = JSON.parse(localStorage.getItem("currentUserUniversityInfo") || "{}");
        var forAllTranche = false;
        if (currentUserUniversityInfo.universityId === UniversityEnum.BUKETOVA_KARAGANDA.id) {
          forAllTranche = true;
        }
        if (!forAllTranche && this.setting.defaultTrancheNumber != 4) {
          showInfoNotify("Только на 4 транше можно формировать отчеты для первокурсник.");
          return;
        }
        this.isLoading = true;

        await reportService.generateReport(reportType);

        this.reloadList();
      } catch (error) {
        if (error.response.status === 409) {
          showErrorNotify(error.response.data);
        } else {
          console.error("Ошибка при выгрузке отчета:", error);
          showErrorNotify("Ошибка при выгрузке отчета");
        }
      } finally {
        this.isLoading = false;
      }
    },
    async onClickDownloadFile(fileId, name, fileExtention) {
      try {
        await fileService.download(fileId, `${name}.${fileExtention}`);
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    translateStatus(code) {
      const status = ReportStatusEnum[code];
      if (status) {
        return status.nameRu;
      }
      return "Неизвестно";
    },
    getStatusClass(status) {
      if (status === "FILES_GENERATED") {
        return "status-generated";
      } else if (status === "FILES_GENERATING") {
        return "status-generating";
      } else if (status === "ERROR_ON_FILES_GENERATING") {
        return "status-error";
      }
      return "";
    },
    canViewRemove() {
      return this.isAdmin() ||
          ((this.isUniversityManager() || this.isRector())
          && this.setting.defaultTrancheNumber == this.page.filter.trancheNumber && this.setting.defaultTrancheYear == this.page.filter.trancheYear);

    },
    canRemove(report) {
      if (!report) {
        return false;
      }

      if (report.reportStatus === ReportStatusEnum.QUEUED.code
          || report.reportStatus === ReportStatusEnum.FILES_GENERATING.code
          || report.reportStatus === ReportStatusEnum.SENT_FOR_APPROVAL.code
          || (!this.isAdmin() && report.reportStatus === ReportStatusEnum.SIGNED_BY_RECTOR.code)) {
        return false;
      }
      return true;
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот отчет?");
      if (confirmed) {
        try {
          this.isLoading = true;

          await reportService.deleteById(item.uuid);

          this.isLoading = false;

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    async onClickExportReports() {
      this.isLoading = true;
      const response = await xlsExportService.exportReports(this.page);
      const blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "document.xlsx");
      this.isLoading = false;
    },
    hasEditPermission() {
      return this.isUniversityManager();
    },
    canViewReport(report) {
      if (report.reportStatus === ReportStatusEnum.QUEUED
          || report.reportStatus === ReportStatusEnum.FILES_GENERATING) {
        return false;
      }
      return this.isUniversityManager() || this.isRector() || this.isManagerFC();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    isRector() {
      return delegationService.isRector();
    },
    isAudit() {
      return delegationService.isAudit();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    async initSettings() {
      this.setting = await settingsService.load();
    }
  },
  mounted() {
    this.initUniversities();

    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

h1 {
  text-align: center;
  margin-top: 20px;
}

.col-university {
}

.col-name {
}

.col-report-type-count {
  width: 130px !important;
  text-align: center;
}

.col-total-sum {
  width: 130px !important;
}

.col-status {
  width: 200px !important;
}

.col-files {
  width: 70px !important;
}

.col-actions {
  width: 10%;
}

.btn-icon {
  font-size: 30px;
  cursor: pointer;
  transition: color 0.3s;
}

.btn-excel {
  color: green;
}

.btn-pdf {
  color: #c43838;
}


.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

h2 {
  text-align: center;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.reports-table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
}

.reports-table th,
.reports-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.reports-table th {
  background-color: #4caf50;
  color: white;
}

.active-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.active-link:hover {
  text-decoration: underline;
}

.inactive-link {
  color: gray;
}

.error-link {
  color: red;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.status-error {
  color: red;
}

.status-generating {
  color: #e78d29;
}

.status-generated {
  color: #267e37;
}

</style>
